import { useEffect, useState } from 'react';

function useStorage(key, initialValue, storage) {
    //state to store the value
    //pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
        try {
            //get from local storage by key
            const item = storage.getItem(key);
            //parse stored json or if none return initialValue
            if (!item) {
                const valueToStore = initialValue instanceof Function ? initialValue() : initialValue;
                storage.setItem(key, JSON.stringify(valueToStore));
                return initialValue;
            }
            return JSON.parse(item);
        } catch (error) {
            //if there's an error getting the key set the value and return the initial value
            const valueToStore = initialValue instanceof Function ? initialValue() : initialValue;
            storage.setItem(key, JSON.stringify(valueToStore));
            return initialValue;
        }
    });

    //Return a wrapped version of useState's setter function that
    //persists the new value to localStorage.
    const setValue = value => {
        try {
            //value can be a function (to have the same API as setState), in that case
            //we call the function to store the value
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            //save the value 
            setStoredValue(valueToStore);
            //save to local storage
            storage.setItem(key, JSON.stringify(valueToStore));
            const storageEvent = new StorageEvent("storage", {
                storageArea: storage,
                newValue: JSON.stringify(valueToStore),
                key,
            });
            window.dispatchEvent(storageEvent);
        } catch (error) { console.log(error); }
    };

    useEffect(() => {
        const storageHandler = e => {
            if (e.storageArea === storage && e.key === key) {
                setStoredValue(JSON.parse(e.newValue));
            }
        };
        window.addEventListener("storage", storageHandler);
        return () => window.removeEventListener("storage", storageHandler);
    }, [storage, key]);

    return [storedValue, setValue];
}

export default useStorage;